/**
 * Slug utilities for the SEO-friendly ranking routes.
 *
 * URL shape: /rankings/{country_lower}/{subject_slug}
 *   e.g. /rankings/uk/economics
 *        /rankings/us/computer-science
 *        /rankings/au/accounting-and-finance
 *
 * The country segment is a lowercased ISO2 (uk/us/au/ca). Subject
 * slugs are lowercased with punctuation stripped and spaces →
 * hyphens. Reversing the slug back to the exact subject_area needs a
 * lookup against the /rankings/subject-index so we handle special
 * chars (& in "Film & Media", spaces vs hyphens) faithfully.
 */

export function subjectSlug(subject) {
  if (!subject) return "";
  return subject
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function findSubjectBySlug(slug, subjects) {
  if (!slug || !subjects) return null;
  const target = slug.toLowerCase();
  return subjects.find((s) => subjectSlug(s) === target) || null;
}

export const COUNTRY_META = {
  uk: { code: "UK", label: "United Kingdom", tld: "uk" },
  us: { code: "US", label: "United States", tld: "us" },
  au: { code: "AU", label: "Australia", tld: "au" },
  ca: { code: "CA", label: "Canada", tld: "ca" },
  nl: { code: "NL", label: "Netherlands", tld: "nl" },
  fr: { code: "FR", label: "France", tld: "fr" },
  de: { code: "DE", label: "Germany", tld: "de" },
  ie: { code: "IE", label: "Ireland", tld: "ie" },
  it: { code: "IT", label: "Italy", tld: "it" },
  es: { code: "ES", label: "Spain", tld: "es" },
  dk: { code: "DK", label: "Denmark", tld: "dk" },
  se: { code: "SE", label: "Sweden", tld: "se" },
  no: { code: "NO", label: "Norway", tld: "no" },
  nordics: { code: "NORDICS", label: "Nordics (DK · SE · NO · FI)", tld: "nordics" },
};
